import { create } from 'zustand';

interface FavoritesStoreState {
  favoriteCount: number;
  favoriteSKUs: Set<string>;
  setFavoriteCount: (count: number) => void;
  setFavoriteSKUs: (skus: string[]) => void;
  toggleFavoriteSKU: (sku: string) => void;
  isFavoriteSKU: (sku: string) => boolean;
}

export const useFavoritesStore = create<FavoritesStoreState>((set, get) => ({
  favoriteCount: 0,
  favoriteSKUs: new Set(),
  setFavoriteCount: (count: number) => set({ favoriteCount: count }),
  setFavoriteSKUs: (skus: string[]) => set({ favoriteSKUs: new Set(skus) }),
  toggleFavoriteSKU: (sku: string) => {
    const next = new Set(get().favoriteSKUs);
    if (next.has(sku)) {
      next.delete(sku);
    } else {
      next.add(sku);
    }
    set({ favoriteSKUs: next, favoriteCount: next.size });
  },
  isFavoriteSKU: (sku: string) => get().favoriteSKUs.has(sku),
}));
